import { Grid } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import CardContainer from '../../../../common/components/cards/cardContainer';
import { rootSelector } from '../../../../common/selectors/selectors';
import {
  createUserActions,
  updateUserActions,
  userActions,
} from '../../users.actions';
import { getRolesActions } from '../../../../common/actions/roles.actions';
import { UserDto, userInit } from '../../users.dtos';
import UserForm from './userForm';
import { iAdmin } from '../../../../common/constants/strings';

interface DetailParams {
  id: string;
}

const UserDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const systemUser = rootSelector((state) => state.users.user);
  const systemRoles = rootSelector((state) => state.roles.roles);

  const [user, setUser] = React.useState<UserDto>(userInit);

  useEffect(() => {
    dispatch({ type: getType(getRolesActions.request) });
  }, []);

  useEffect(() => {
    if (match.params.id !== undefined) {
      dispatch({
        type: getType(userActions.request),
        payload: match.params.id,
      });
    }
  }, [match.params.id, dispatch]);

  useEffect(() => {
    if (match.params.id !== undefined) {
      setUser(systemUser);
    } else {
      setUser(userInit);
    }
  }, [systemUser, dispatch, match.params.id]);

  const onClose = () => history.push('/users');

  const onSave = (user: UserDto) => {
    let allNew = user.id === '';
    const adminRole = [...systemRoles].find((f) => f.name === iAdmin);
    if (user.roles === undefined && adminRole != null) {
      user.roles = [{ roleId: adminRole?.roleId, name: adminRole.name }];
    }

    dispatch({
      type: allNew
        ? getType(createUserActions.request)
        : getType(updateUserActions.request),
      payload: { ...user },
    });
  };

  return (
    <CardContainer
      title='User Details'
      cards={
        <Grid item sm={5}>
          <UserForm user={user} onClose={onClose} onSave={onSave} />
        </Grid>
      }
    />
  );
};

export default UserDetails;
